import type { Viewport, XYPosition } from '../types';

/**
 * Renderer point → flow position. The point is relative to the pane's top-left corner,
 * like v11 `project()`; subtract the pane's client offset first for raw mouse coordinates.
 */
export const pointToFlow = ({ x, y }: XYPosition, { x: tx, y: ty, zoom }: Viewport): XYPosition => ({
  x: (x - tx) / zoom,
  y: (y - ty) / zoom,
});

/** Flow position → renderer point (relative to the pane). Inverse of `pointToFlow`. */
export const pointToRenderer = ({ x, y }: XYPosition, { x: tx, y: ty, zoom }: Viewport): XYPosition => ({
  x: x * zoom + tx,
  y: y * zoom + ty,
});
